module.exports = __webpack_public_path__ + "0214687baa25d4adc22f78fee4a47f0f.png";